import { Component, Input } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { RouterLink } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { AlertComponent } from '../../common/alert/alert.component';

@Component({
  selector: 'app-content',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    AlertComponent
  ],
  templateUrl: './content.component.html'
})
export class ContentComponent {
  constructor() {
  }
}
